export enum NotificationType {
  ERROR = "ERROR",
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  CANCEL = "CANCEL",
}
